import { APP_ROUTES } from 'app/constants';
import { MenuItem } from './menu.model';
import { Permission } from 'app/enums';

const CUSTOMER_MENU: MenuItem = {
    translationKey: 'MENU.CUSTOMER',
    icon: 'corporate_fare',
    iconType: 'solid',
    route: APP_ROUTES.CustomerList,
    anyPermission: [Permission.WriteCounterpart]
};

const COUNTERPART_MENU: MenuItem = {
    translationKey: 'MENU.COUNTERPART',
    icon: 'handshake',
    iconType: 'solid',
    route: APP_ROUTES.CounterpartList,
    anyPermission: [Permission.WriteCounterpart]
};

const INBOX_MENU: MenuItem = {
    translationKey: 'MENU.INBOX',
    //icon: 'envelope',
    icon: 'inbox',
    iconType: 'solid',
    route: APP_ROUTES.InboxList,
    anyPermission: [Permission.ReadInbox]
};

const USER_MENU: MenuItem = {
    translationKey: 'MENU.USER',
    icon: 'group',
    iconType: 'solid',
    route: APP_ROUTES.UserList,
    anyPermission: [Permission.ReadUser]
};

const AGREEMENT_MENU: MenuItem = {
    translationKey: 'MENU.AGREEMENT',
    icon: 'contract',
    iconType: 'solid',
    route: APP_ROUTES.AgreementList,
    anyPermission: [Permission.ReadAgreement]
};

const INVENTORY_MENU: MenuItem = {
    translationKey: 'MENU.INVENTORY',
    icon: 'inventory_2',
    iconType: 'solid',
    route: APP_ROUTES.InventoryList,
    anyPermission: [Permission.ReadAgreement]
};

const DASHBOARD_MENU: MenuItem = {
    translationKey: 'MENU.DASHBOARD',
    //icon: 'house',
    icon: 'home',
    iconType: 'solid',
    route: APP_ROUTES.Dashboard,
    anyPermission: [Permission.ReadAgreement]
};

const CALENDAR_MENU: MenuItem = {
    translationKey: 'MENU.CALENDAR',
    icon: 'calendar_today',
    iconType: 'solid',
    route: APP_ROUTES.Calendar,
    anyPermission: [Permission.ReadAgreement]
};

const LISTTYPE_MENU: MenuItem = {
    translationKey: 'MENU.LISTTYPE',
    icon: 'playlist_add',
    iconType: 'solid',
    route: APP_ROUTES.ListTypeList,
    anyPermission: [Permission.WriteAgreement]
};

export const MENU: MenuItem[] = [
    DASHBOARD_MENU,
    AGREEMENT_MENU,
    INVENTORY_MENU,
    CALENDAR_MENU,
    INBOX_MENU,
    COUNTERPART_MENU,
    CUSTOMER_MENU,
    LISTTYPE_MENU,
    USER_MENU
];
